module.exports = __webpack_public_path__ + "annualreview2017/static/img/coordinating-smart-appliances-to-offer-flexible-services@0,5x.51d006e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prosumer-wide/coordinating-smart-appliances-to-offer-flexible-services@0,5x.png
// module id = 789
// module chunks = 0